<template>
  <span class="adm-badge" :class="[`adm-tone-${tone}`, { 'adm-badge--pill': pill }]">
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
/**
 * Etiqueta de estado — plan 27_09_2026 §4.2.
 *
 * Absorbe los 9 pares `.badge-*` / `.status-*` que `Print3DOrdenesPage`
 * definía a mano con colores de una paleta ajena. Los tonos salen ahora de
 * los tokens de estado de `admin.css`, derivados de la paleta de marca.
 *
 * Uso: `<AdmBadge :status="o.status" />` traduce etiqueta y tono a la vez;
 * `<AdmBadge tone="warn">Texto</AdmBadge>` para casos sueltos.
 */

/** Estados de una solicitud 3D → { label, tone }. */
export const ORDER_STATUS = {
  received: { label: 'Recibida', tone: 'info' },
  in_review: { label: 'En revisión', tone: 'warn' },
  quoted: { label: 'Cotizada', tone: 'ok' },
  rejected: { label: 'Rechazada', tone: 'danger' },
  closed: { label: 'Cerrada', tone: 'neutral' },
};

/** Tipos de solicitud → { label, tone }. */
export const REQUEST_TYPE = {
  print_only: { label: 'STL', tone: 'info' },
  modeling_and_print: { label: 'Modelado', tone: 'warn' },
  catalog_order: { label: 'Catálogo', tone: 'neutral' },
  custom_order: { label: 'Personalizado', tone: 'info' },
};

export default {
  name: 'AdmBadge',
  props: {
    /** Tono explícito: ok | warn | danger | info | neutral. */
    tone: { type: String, default: 'neutral' },
    label: { type: String, default: '' },
    pill: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.adm-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.15rem 0.55rem;
  border-radius: var(--adm-radius-sm);
  font-family: var(--font-body);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
}

.adm-badge--pill { border-radius: 999px; }
</style>
